import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { withClientState } from 'apollo-link-state';
import { createUploadLink } from 'apollo-upload-client';
import * as Sentry from '@sentry/browser';
const uuid = require('uuid/v4');

export const createClient = ({ cache, ssrMode, getAccessToken }) => {
  // const httpLink = new HttpLink({ uri: '/graphql' });
  const getHeaders = (headers) => {
    // get the authentication token from local storage if it exists
    return {
      headers: {
        ...headers,
        Authorization: `Bearer ${getAccessToken()}`,
        'noble-trace-id': uuid(),
      },
    };
  };

  const authSetContext = (_, { headers }) => {
    return getHeaders(headers);
  };

  const authLink = setContext(authSetContext);

  const errorLink = onError((error) => {
    const headers = error.operation.getContext().headers;
    const traceId = headers ? headers['noble-trace-id'] : undefined;
    if (traceId) {
      if (error.graphQLErrors) {
        for (let graphqlError of error.graphQLErrors) {
          if (graphqlError.extensions) {
            graphqlError.extensions.traceId = traceId;
          }
        }
      }

      Sentry.addBreadcrumb({
        type: 'network_error',
        data: {
          operationName: error.operation.operationName,
          traceId,
        },
      });
    }
  });

  const stateLink = withClientState({
    cache,
    resolvers: {},
  });

  const client = new ApolloClient({
    cache,
    ssrMode,
    // link: ApolloLink.from([stateLink, authLink, errorLink, clearErrorLink, createUploadLink({ uri: '/graphql' })]),
    link: ApolloLink.from([stateLink, authLink, errorLink, createUploadLink({ uri: '/graphql' })]),
  });

  return client;
};
